import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Card, Button, TextField, Typography, CircularProgress } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import { getSystemById, updateSystem } from "../../../reducer/system/action";

function EmailConfig(props) {
  const [values, setValues] = useState({
    email: "",
    emailPassword: "",
  });
  const [editing, setEditing] = useState(false);
  const [helperText, setHelperText] = useState(false);

  useEffect(() => {
    props.getSystemById(2);
  }, []);

  useEffect(() => {
    if (props.systemDetail && props.systemDetail.id) {
      setValues({
        email: props.systemDetail.email || "",
        emailPassword: props.systemDetail.emailPassword || "",
      });
    }
  }, [props.systemDetail]);

  const handleChangeForm = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const handleStartEdit = () => {
    setValues({
      ...values,
      emailPassword: "",
    });
    setEditing(true);
  };

  const handleCancel = () => {
    setValues({
      email: props.systemDetail.email || "",
      emailPassword: props.systemDetail.emailPassword || "",
    });
    setEditing(false);
    setHelperText(false);
  };

  const handleSubmit = async () => {
    if (!values.email || !values.emailPassword) {
      setHelperText(true);
      return;
    }

    const success = await props.updateSystem(2, values);
    if (success) {
      setEditing(false);
      setHelperText(false);
    }
  };

  if (props.isFetching && !props.systemDetail?.id) {
    return (
      <Card style={{ padding: 20, minHeight: 200, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </Card>
    );
  }

  return (
    <Card style={{ padding: 20 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Cấu hình gửi Email
          </Typography>
          <Alert severity="info" style={{ marginBottom: 16 }}>
            Cấu hình thông tin email dùng để gửi thông báo tự động từ hệ thống
          </Alert>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            label="Email"
            variant="outlined"
            value={values.email}
            disabled={!editing}
            required
            error={helperText && !values.email}
            helperText={helperText && !values.email ? "Vui lòng nhập email" : ""}
            onChange={(event) => handleChangeForm("email", event.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            label="Mật khẩu Email"
            variant="outlined"
            type="password"
            value={values.emailPassword}
            disabled={!editing}
            required
            error={helperText && !values.emailPassword}
            helperText={helperText && !values.emailPassword ? "Vui lòng nhập mật khẩu email" : ""}
            onChange={(event) => handleChangeForm("emailPassword", event.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            {!editing ? (
              <Button variant="contained" color="primary" onClick={handleStartEdit}>
                Chỉnh sửa
              </Button>
            ) : (
              <>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Hủy
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={props.isFetching}>
                  {props.isFetching ? <CircularProgress size={24} /> : "Lưu"}
                </Button>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </Card>
  );
}

const mapStateToProps = (state) => ({
  systemDetail: select(state, "systemReducer", "detail"),
  isFetching: select(state, "systemReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  getSystemById: (id) => dispatch(getSystemById(id)),
  updateSystem: (id, payload) => dispatch(updateSystem(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(EmailConfig));

